import api from "../../../services/api/axios";

export const uploadIncubatorLeaseDocument = (incubatorId, file) => {
  const form = new FormData();
  form.append("file", file, file.name);

  return api.post(`/incubators/${incubatorId}/lease-document`, form);
};

export const downloadIncubatorLeaseDocument = (incubatorId, documentId) =>
  api.get(`/incubators/${incubatorId}/lease-documents/${documentId}`, {
    responseType: "blob",
  });

export const deleteIncubatorLeaseDocument = (incubatorId, documentId) =>
  api.delete(`/incubators/${incubatorId}/lease-documents/${documentId}`);
